module.exports = __webpack_public_path__ + "img/xomo.45a9be19.png";